/* unplugin-vue-components disabled */
import $chats, {Chat} from 'stores/chats'
import $global from 'stores/global'
import {TASK_STATUS} from 'utils/tasks'

export default {
  props: {
    active: {
      type: Boolean, default: false
    },
    chat: {
      type: Chat,
      required: true
    },
  },
  emits: ['show'],
  data() {
    return {
      hovered: false,
      show_popover: false,
      editable: false,
      can_accept: false
    }
  },
  computed:{
    title(){
      return $utils.str.decodeHTMLEntities(this.chat.title)
    },
    task(){
      return this.chat.task_id
    },
    completed(){
      return $chats.statuses[this.task] === TASK_STATUS.COMPLETED
    },
    failed(){
      return $chats.statuses[this.task] === TASK_STATUS.FAILED
    },
    show_status(){
      if (!this.task) return false
      if (!this.$responsive.desktop) return true
      if (this.hovered || this.show_popover) return false
      return true
    }
  },
  watch: {
    completed(cur){
      if (this.active || !cur) return
      $utils.toasts.success(`Chat <b>${this.title}</b> is ready.`, 5000)
    }
  },
  beforeUnmount() {
    this.hide()
  },
  methods:{
    hide(){
      this.$emit('show', {id: this.chat.id, show: false})
    },
    onEdit() {
      this.editable = true
      this.can_accept = false
      this.$nextTick(() => {
        const input = this.$refs.input
        input.focus()
        const r = document.createRange()
        const s = window.getSelection()
        r.setStart(input, 1) 
        r.setEnd(input, 1)    
        s.removeAllRanges()
        s.addRange(r)
      })
    },
    restoreTitle() {
      const input = this.$refs.input
      if (!input) return
      input.innerText = $utils.str.decodeHTMLEntities(this.chat.title)
    },
    onShow(){
      this.$emit('show', {id: this.chat.id, show: true})
      this.show_popover = true
    },
    onBlur(ev) {
      this.editable = false
      this.hide()
      this.restoreTitle()
    },
    onCancel(){
      this.restoreTitle()
      this.editable = false
    },
    onAccept() {
      this.setNewTitle()
    },
    async setNewTitle(){
      this.editable = false
      this.show_popover = false
      this.chat.setTitle(this.$refs.input.innerText)
      await this.chat.save()
    },
    onKeydown(e){
      const prevent = [13, 27].includes(e.keyCode)
      if (prevent) {
        e.preventDefault()
        if (e.keyCode === 13) {
          if (this.can_accept) this.setNewTitle()
          this.show_popover = false
          return
        }
        if (e.keyCode === 27) {
          this.restoreTitle()
          this.show_popover = false
          return
        }
      }
      // title length limit
      if (this.$refs.input.innerText.length === 512 && e.keyCode !== 8) {
        e.preventDefault()
        return
      }
    },
    onInput() {
      const text = this.$refs.input.innerText.trim()
      this.can_accept = text.length > 0 && this.chat.title !== text
    },
    async onRemove() {
      this.show_popover = false
      await $chats.removeChat(this.chat.id)
      $global.goToChats()
    }
  }
}
